import React, { useState } from "react";

//=== Packages == //
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Button from "@mui/material/Button";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import TextField from "@mui/material/TextField";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import Image from "next/image";
import CartIcon from "./shopping-cart.svg";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";

//=== Components == //
import Buttons from "../Button/Button";
import QuantityField from "../QuantityField/QuantityField";
import Modals from "../Modals/Modals";
import Tooltip from "../Tooltip/Tooltip";

import "./ShoppingCartListing.css";
import { useShoppingCart } from "../../../../contexts/CartContext";
import { apiRequest } from "../../../../utils/axiosInstance";
import { CURRENCY_SIGNS, getUserData } from "../../../../hooks/HelperFunctions";
import { toast } from "react-toastify";

import styles from './Shopping.module.css';

import { useSelector } from "react-redux";
// const shoppingData = [
//   {
//     Img: product,
//     Title: "Quranic Arabic Language Level -1",
//     Description: "Ustazah Nurjahan Rosul (Moyna)",

//     PaymentPlan:true,
//     PaymentTypeLabel:"Pay in full",
//     PaymentMethodLabel:"- One-time payment of:",
//     Payment:"$2000",

//     Save:true,
//     SaveLabel:"10",
//     Off:"10%",

//     OldPrice:"$4000",
//     NewPrice: "$3600",

//     Edit:true,
//     //onClickEdit:onClickEdit,
//     Remove:true,
//     //onClickRemove:onClickRemove,
//     AddCourseCoupon:true,
//     //onClickAddCourseCoupon:onClickAddCourseCoupon,
//     SaveForLater:true,
//     //onClickSaveForLater:onClickSaveForLater,

//     QuantityField:true,

//   },

// ]

function ShoppingCartListing(props) {
  const activeCurrency = useSelector(
    (state) => state.currency.activeCurrency
  );
  //=======  CouponCode Product===== //
  const [openAddProductCoupon, setOpenAddProductCoupon] = useState(false);
  const [activeCourseIdToAddCoupon, setActiveCourseIdToAddCoupon] =
    useState("");
  const [couponCodeToAdd, setCouponCodeToAdd] = useState("");
  const [couponCodeNotFoundError, setCouponCodeNotFoundError] = useState(false);
  const { cartItems, setCartItems, cartItemsCoupons, setCartItemsCoupons } =
    useShoppingCart();

  const handleOpenAddProductCoupon = () => {
    setOpenAddProductCoupon(true);
  };
  const handleCloseAddProductCoupon = () => {
    setOpenAddProductCoupon(false);
  };
  //=======  CouponCode Product===== //

  //=======  CouponCode Platform ===== //
  const [openCouponCode, setOpenCouponCode] = useState(false);
  const handleOpenCouponCode = () => {
    setOpenCouponCode(true);
  };
  const handleCloseCouponCode = () => {
    setOpenCouponCode(false);
  };
  //=======  CouponCode Platform ===== //

  //=======  Remove ===== //
  const [openRemove, setOpenRemove] = useState(false);
  const handleOpenRemove = () => {
    setOpenRemove(true);
  };
  const handleCloseRemove = () => {
    setOpenRemove(false);
  };
  //=======  CouponCode ===== //

  const showCouponCode = (courseId, coupon) => {
    let foundInCartItems = cartItems
      ?.find((course) => course?.courseId == courseId)
      ?.active_coupons?.find((singleCoupon) => singleCoupon?.id == coupon);

    if (!foundInCartItems) {
      let triedCoupons = localStorage.getItem("tried_coupons")
        ? JSON.parse(localStorage.getItem("tried_coupons"))
        : [];
      let foundInTriedCoupon = triedCoupons.find(
        (singleCoupon) => singleCoupon?.id == coupon
      );

      return foundInTriedCoupon?.coupon_code;
    }
    return foundInCartItems?.coupon_code;
  };

  
  const showOff = (courseId, coupon) => {
    let foundCourse = cartItems?.find((course) => course?.courseId == courseId)

    let foundInCartItems = foundCourse?.active_coupons?.find((singleCoupon) => singleCoupon?.id == coupon);

    const baseUsd = foundCourse?.base_usd_price;
    const currency = foundCourse?.currency
    const current_currency_price = foundCourse?.price;
    const rate = current_currency_price/baseUsd;

    const fixedCouponUsd = foundInCartItems?.discount_value;

    const discountedUsd = Math.max(0, baseUsd - fixedCouponUsd);
    

    let offToShow = ""
    let discountedCurrentCurrencyAmount = 0
    
    if(foundInCartItems?.discount_type == "percentage"){
      offToShow = `(${parseInt(foundInCartItems?.discount_value)}% off)`
    }else{
      discountedCurrentCurrencyAmount = Number((fixedCouponUsd * rate).toFixed(2));
      discountedCurrentCurrencyAmount = (currency == "USD" ) ? parseInt(discountedCurrentCurrencyAmount) : discountedCurrentCurrencyAmount
      offToShow = `(${getTheCorrectCurrencySign()}${discountedCurrentCurrencyAmount} off)`
    }


    if (!foundInCartItems) {
      let triedCoupons = localStorage.getItem("tried_coupons")
        ? JSON.parse(localStorage.getItem("tried_coupons"))
        : [];
      let foundInTriedCoupon = triedCoupons.find(
        (singleCoupon) => singleCoupon?.id == coupon
      );

      if(foundInTriedCoupon?.discount_type == "percentage"){
        offToShow = `(${parseInt(foundInTriedCoupon?.discount_value)}% off)`
      }else{
        const fixedCouponUsdInsideTried = foundInTriedCoupon?.discount_value;

        discountedCurrentCurrencyAmount = Number((fixedCouponUsdInsideTried * rate).toFixed(2));
        discountedCurrentCurrencyAmount = (currency == "USD") ? parseInt(discountedCurrentCurrencyAmount) : discountedCurrentCurrencyAmount
        offToShow = `(${getTheCorrectCurrencySign()}${discountedCurrentCurrencyAmount} off)`
      }

    }

    let thisCourseCoupons = cartItemsCoupons?.find(
      (singleCourse) => singleCourse?.courseId == courseId
    );
    let courseDetails = cartItems?.find((single_course) => single_course?.courseId == courseId)

    let isDiscountExceedMainPrice = checkDiscountExceedMainPrice(courseDetails, thisCourseCoupons)


    if (isDiscountExceedMainPrice) {
      return `(100% off)`
    }

    return offToShow

  };

  const removeThisCouponFromThisCourse = (courseId, coupon) => {
    let shallowCopyOfCartItemsCoupons = [...cartItemsCoupons];
    let currentCourseCoupons = shallowCopyOfCartItemsCoupons?.filter(
      (singleCourse) => singleCourse?.courseId != courseId
    );
    let thisCourseCoupons = cartItemsCoupons?.find(
      (singleCourse) => singleCourse?.courseId == courseId
    );
    thisCourseCoupons.couponIds = thisCourseCoupons?.couponIds?.filter(
      (singleCouponId) => singleCouponId != coupon
    );

    currentCourseCoupons =
      thisCourseCoupons?.couponIds?.length > 0
        ? [...currentCourseCoupons, thisCourseCoupons]
        : [...currentCourseCoupons];
    localStorage.setItem("itemsCoupons", JSON.stringify(currentCourseCoupons));

    setCartItemsCoupons(currentCourseCoupons);
  };

  const checkDiscountExceedMainPrice = (courseDetails, thisCourseCoupons) => {
    console.log(courseDetails, 'courseDetails')
    const coursePrice = parseFloat(courseDetails?.base_usd_price) || 0;
    const activeCoupons = courseDetails?.active_coupons || [];
    const couponIds = thisCourseCoupons?.couponIds || [];
  
    // Get localStorage coupons once (if needed)
    const triedCoupons = JSON.parse(localStorage.getItem("tried_coupons") || "[]");
  
    //if not found in active coupons try to local storage coupons tried 
    const getCouponDetails = (couponId) =>  activeCoupons.find((c) => c.id == couponId) || triedCoupons.find((c) => c.id == couponId);
  
    const totalDiscountAmount = couponIds.reduce((acc, couponId) => {
      const coupon = getCouponDetails(couponId);
      if (!coupon) return acc;
  
      const { discount_type, discount_value } = coupon;
      const value = parseFloat(discount_value) || 0;
  
      if (discount_type === "fixed") {
        return acc + value;
      } else if (discount_type === "percentage") {
        return acc + (value / 100) * coursePrice;
      }
  
      return acc;
    }, 0);
  
    return totalDiscountAmount >= coursePrice;
  };

  const getThisCourseCoupons = (courseId, coupon) => {
    let thisCourseCoupons = cartItemsCoupons?.find(
      (singleCourse) => singleCourse?.courseId == courseId
    );
    if (!thisCourseCoupons) {
      thisCourseCoupons = {
        courseId: courseId,
        couponIds: [coupon],
      };
    } else {
      let foundCoupon = thisCourseCoupons?.couponIds?.find(
        (singleCoupon) => singleCoupon == coupon
      );

      if (!foundCoupon) {
        thisCourseCoupons.couponIds.push(coupon);
      }
    }
    return thisCourseCoupons
  }

  const addThisCouponToThisCourse = (courseId, coupon) => {
    let shallowCopyOfCartItemsCoupons = [...cartItemsCoupons];
    let currentCourseCoupons = shallowCopyOfCartItemsCoupons?.filter(
      (singleCourse) => singleCourse?.courseId != courseId
    );

    let thisCourseCoupons = getThisCourseCoupons(courseId, coupon)
    let courseDetails = cartItems?.find((single_course) => single_course?.courseId == courseId)

    let isDiscountExceedMainPrice = checkDiscountExceedMainPrice(courseDetails, thisCourseCoupons)

    if(isDiscountExceedMainPrice){
      toast.success("Maximum discount applied. You saved 100%!")
    }
    
    currentCourseCoupons =
      thisCourseCoupons?.couponIds?.length > 0
        ? [...currentCourseCoupons, thisCourseCoupons]
        : [...currentCourseCoupons];
    localStorage.setItem("itemsCoupons", JSON.stringify(currentCourseCoupons));

    setCartItemsCoupons(currentCourseCoupons);
  };

  const addCouponModalOpenHandler = (courseId) => {
    setActiveCourseIdToAddCoupon(courseId);
    handleOpenAddProductCoupon();
  };

  const sendCouponHandler = async () => {
    let postData = {
      course_id: activeCourseIdToAddCoupon,
      coupon_code: couponCodeToAdd,
    };
    let userInfo = getUserData();
    if (userInfo && userInfo?.id != "") {
      postData.user_id = userInfo?.id;
    }
          
      
    
    try {
      const data = await apiRequest(
        "/getCouponInfoByCouponCode",
        "POST",
        postData
      );

      if (!data?.error) {
        setActiveCourseIdToAddCoupon("");
        handleCloseCouponCode();
        console.log(data?.data);
        setCouponCodeNotFoundError(false);
        handleCloseAddProductCoupon();

        addThisCouponToThisCourse(
          activeCourseIdToAddCoupon,
          data?.data?.[0]?.id
        );

        let triedCouponsBefore = localStorage.getItem("tried_coupons")
          ? JSON.parse(localStorage.getItem("tried_coupons"))
          : [];
        let foundTriedCoupon = triedCouponsBefore?.find(
          (singleCoupon) => singleCoupon?.id == data?.data?.[0]?.id
        );
        if (!foundTriedCoupon) {
          triedCouponsBefore.push(data?.data[0]);
          localStorage.setItem(
            "tried_coupons",
            JSON.stringify(triedCouponsBefore)
          );
        }else{
          toast.error(`${data?.data?.[0]?.coupon_code} - Coupon already applied`)
        }
      } else {
        setCouponCodeNotFoundError(true);
      }
      // setOpenBackdrop(false);
    } catch (error) {
      setActiveCourseIdToAddCoupon("");
      handleCloseCouponCode();
      console.log(error);

      // setIsStripeConnectedForOrg(false);
      // setOpenBackdrop(false);
    }
  };

  const closeAddCouponModalHandler = () => {
    setCouponCodeNotFoundError(false);
    setCouponCodeToAdd("");
    handleCloseAddProductCoupon();
  };

  const getTheCorrectCurrencySign = () => {
    return CURRENCY_SIGNS[activeCurrency] ?? "$";
  };
  return (
    <div className="PM_ShoppingCartListingContainer">
      {props.shoppingData?.map((item, i) => (
        <div className="PM_ShoppingCartListing">
          <div className="PM_ShoppingCartListingCard">
            <div className="PM_ShoppingCartListingLeftCol">
              <div className="PM_ShoppingCartImg">
                <img src={item.Img} alt={item?.Title} />
              </div>

              <div style={{ flex: "1" }}>
                <div className="PM_ShoppingCarProductDetailsContainer">
                  <div className="PM_ShoppingCarProductDetails">
                    <h1>{item.Title}</h1>
                    <div className="PM_ShoppingCarDescription">
                    {item.Description && <p>{item.Description}</p>}
                    {item.organizationName && <p>{item.organizationName}</p>}
                    </div>
                    {item.SelectedCoursesQuantity && (
                      <Button
                        className="PM_SelectedCoursesQuantity"
                        variant="text"
                        onClick={item.handleOpenCoursesQuantity}
                      >
                        {item.SelectedCoursesQuantityLabel}{" "}
                        <ArrowForwardIosRoundedIcon />
                      </Button>
                    )}

                    {item.PaymentPlan && (
                      <div className="PM_Payment_Price">
                        <div className="PM_CheckStatus">
                          <CheckCircleRoundedIcon />
                        </div>
                        <div className="PM_Payment_Type">
                          {item.PaymentTypeLabel}
                          <span>{item.PaymentMethodLabel}</span>
                        </div>
                        <h1>{item.Payment}</h1>
                      </div>
                    )}
                    <div className="PM_SaveSectionContainer">
                      {item.Save &&
                        item?.couponFound &&
                        item.couponFound.map((coupon, index) => (
                          <div className="PM_SaveSection" key={index}>
                            <div className="PM_SaveChip">
                              <LocalOfferRoundedIcon />
                              <span>
                                {showCouponCode(item?.courseId, coupon)}{" "}
                                {showOff(item?.courseId, coupon)}
                              </span>
                              <CloseRoundedIcon
                                onClick={(e) =>
                                  removeThisCouponFromThisCourse(
                                    item?.courseId,
                                    coupon
                                  )
                                }
                              />
                            </div>
                            {/* <div className='PM_OffPrice'></div> */}
                          </div>
                        ))}
                    </div>

                      <div
                        className="PM_ShoppingCartActionSectionLeft"
                        style={{ marginTop: "8px" }}
                      >
                        {item.AddProductCoupon && (
                          <Button
                            className="PM_ShoppingCartActionAddCoupon"
                            variant="text"
                            onClick={(e) =>
                              addCouponModalOpenHandler(item?.courseId)
                            }
                          >
                            {item.AddProductCoupon}
                          </Button>
                        )}
                      </div>
                  </div>

                  <div className="PM_ShoppingCartListingRightCol">
                    {item.QuantityField && (
                      <div className="PM_ProductQuantity">
                        <div className="PM_ProductPriceTitle">Quantity</div>
                        <QuantityField />
                      </div>
                    )}
                    <div className="PM_ProductPriceSection">
                      {/* <div className='PM_ProductPriceTitle'>Total</div> */}
                      <div className="PM_ShoppingCartPrice">
                        {item.NewPrice}
                      </div>
                      <div className="PM_ShoppingCartOldPrice">
                        {item.OldPrice}
                      </div>

                      {item.Remove && (
                        <div className="PM_ShoppingCartRemove">
                          <Tooltip
                            TooltipText="Remove course from cart"
                            Tooltip={
                              <Button
                                variant="text"
                                onClick={item.onClickRemove}
                              >
                                <DeleteForeverOutlinedIcon />
                              </Button>
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="PM_ShoppingCartActionSection">
                  {/* <div className="PM_ShoppingCartActionSectionLeft">
                    {item.AddProductCoupon && (
                      <Button
                        className="PM_ShoppingCartActionAddCoupon"
                        variant="text"
                        onClick={handleOpenAddProductCoupon}
                      >
                        Add course coupon
                      </Button>
                    )}
                  </div> */}

                  <div className="PM_ShoppingCartActionSectionRight">
                    {item.Edit && (
                      <Button
                        variant="text"
                        className="PM_ShoppingCartEdit"
                        onClick={item.onClickEdit}
                      >
                        Edit
                      </Button>
                    )}

                    {item.SaveForLater && (
                      <Tooltip
                        TooltipText="Save for later"
                        Tooltip={
                          <Button
                            variant="text"
                            onClick={item.onClickSaveForLater}
                          >
                            <FavoriteBorderIcon />
                          </Button>
                        }
                      />
                    )}

                    {/* {item.Remove && (
                      <Tooltip
                        TooltipText="Remove"
                        Tooltip={
                          <Button variant="text" onClick={item.onClickRemove}>
                            <DeleteForeverOutlinedIcon />
                          </Button>
                        }
                      />
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {props.SubTotal && (
        <div className="PM_ShoppingCartTotalSection">
          <div className="PM_ShoppingCartSubTotalText">Subtotal</div>
          <div className="PM_ShoppingCartSubTotalText">
            {props.CurrencySign}
            {props.Subtotal}
          </div>
        </div>
      )}

      {props.AddPlatformCoupon && (
        <div className="PM_ShoppingCartTotalSection">
          <Button
            className="PM_ShoppingCartAddCouponText"
            variant="text"
            onClick={handleOpenCouponCode}
          >
            {props.AddPlatformCouponLabel} <HelpRoundedIcon />
          </Button>
        </div>
      )}

      {props.Save && (
        <div className="PM_SaveSection">
          <div className="PM_SaveChip">
            <LocalOfferRoundedIcon /> <span>{props.SaveLabel} </span>
            <CloseRoundedIcon onClick={handleOpenRemove} />
          </div>
          <div className="PM_OffPrice">{props.Off} off</div>
        </div>
      )}

      <div style={{ marginBottom: "16px" }}></div>

      {props?.shoppingData?.length > 0 && (
        <div className="PM_ShoppingCartTotalSection">
          <div className="PM_ShoppingCartTotalText">Total</div>
          <div className="PM_ShoppingCartTotalAmount">
            {props.CurrencySign}
            {props.Total}
          </div>
        </div>
      )}

      {props?.shoppingData?.length > 0 && (
        <div className="PM_ShoppingCartCheckboutButton">
          <Buttons
            label="Checkout"
            buttonColor="#FF6200"
            border="#FF6200 1px solid"
            color="#fff"
            width="100%"
            height="56px"
            fontSize="14px"
            iconAfter={<ArrowForwardRoundedIcon />}
            onClick={props.onClickCheckout}
          />
        </div>
      )}

      {props?.shoppingData?.length > 0 && (
        <div className="PM_ShoppingCartOrSection">
          <div className="PM_ShoppingCartTextOr">or</div>
          <div className="PM_ShoppingCartTextLink">
            <a href={props.BrowsingLink}>Continue Browsing</a>
          </div>
        </div>
      )}

      {props?.shoppingData?.length == 0 && (
        <div className="PM_ShoppingCartEmpty">
          <div>
            <div className="PM_ShoppingCartIcon">
              <Image src={CartIcon} />
            </div>
            <p>You haven't added anything to your cart!</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Buttons
                label="Continue Browsing"
                buttonColor="#004FE0"
                border="#E4E8EC 1px solid"
                color="#fff"
                width="200px"
                height="56px"
                fontSize="14px"
                link={props.BrowsingLink}
              />
            </div>
          </div>
        </div>
      )}

      {/* ==== Add Product Coupon Modal ==*/}
      <Modals
        openDialog={openAddProductCoupon}
        handleCloseDialog={(e) => closeAddCouponModalHandler()}
        title="Enter coupon code"
        body={
          <div className="PM_CouponCode">
            <TextField
              id="outlined-basic"
              variant="outlined"
              placeholder="Enter code here"
              value={couponCodeToAdd}
              onChange={(e) => {
                setCouponCodeToAdd(e.target.value.toUpperCase());
                setCouponCodeNotFoundError(false);
              }}
              error={couponCodeNotFoundError}
              helperText={
                couponCodeNotFoundError ? "Enter a valid coupon code" : ""
              }
              className={styles.PM_CouponCodeField}
            />

            <Buttons
              label="Apply"
              buttonColor="#004FE0"
              border="#E4E8EC 1px solid"
              color="#fff"
              width="100%"
              height="58px"
              fontSize="14px"
              onClick={(e) => sendCouponHandler()}
              // onClick={props.onClickProductCouponApply}
            />
          </div>
        }
        textAlign="center"
      />

      {/* ==== Add Platform Coupon Modal ==*/}
      <Modals
        openDialog={openCouponCode}
        handleCloseDialog={(e) => closeAddCouponModalHandler()}
        title="Enter coupon code"
        body={
          <div className="PM_CouponCode">
            <TextField
              id="outlined-basic"
              variant="outlined"
              placeholder="Enter code here"
              value={props.EnterPlatformCouponCodeValue}
              className={styles.PM_CouponCodeField}
            />

            <Buttons
              label="Apply"
              buttonColor="#004FE0"
              border="#E4E8EC 1px solid"
              color="#fff"
              width="100%"
              height="58px"
              fontSize="14px"
              onClick={props.onClickPlatformCouponApply}
            />
          </div>
        }
        textAlign="center"
      />

      {/* ==== Remove Modal ==*/}
      <Modals
        openDialog={openRemove}
        handleCloseDialog={handleCloseRemove}
        title="Remove this coupon code?"
        body={
          <div>
            Are you sure you want to remove this coupon code?<br></br> Removing
            coupon code will also remove the discount amount.
          </div>
        }
        ModalFooter={true}
        actionButton="Remove"
        handleConfirmCloseDialog={props.onClickRemoveCoupon}
      />
    </div>
  );
}

export default ShoppingCartListing;
